export default "/build/images/humidity_mask.f093b10c.png";